import type { FC } from "react";
import { Select } from "../../components/select/Select";
import { GROUP_TYPE_OPTIONS } from "../groupTypeOptions";
import type { GroupType } from "../orderTypes";

interface Props {
  readonly value: GroupType | undefined;
  readonly onChange: (groupType: GroupType) => void;
}

const GroupTypeSelect: FC<Props> = ({ value, onChange }) => (
  <Select
    label="Rodzaj grupy"
    fullWidth
    value={(value ?? "") as GroupType}
    values={GROUP_TYPE_OPTIONS}
    onSelect={onChange}
  />
);

export default GroupTypeSelect;
